import { render } from "./VirtualsResults.vue?vue&type=template&id=c57739b0"
import script from "./VirtualsResults.vue?vue&type=script&lang=js"
export * from "./VirtualsResults.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__